
const ROOT = { role: 'ROOT', institutionId: -1 };
const ADMINISTRADOR = { role: 'ADMINISTRADOR', institutionId: -1 };
const AUDITOR_RECETAS = { role: 'AUDITOR_RECETAS', institutionId: -1 };
const LECTOR_RECETAS = { role: 'LECTOR_RECETAS', institutionId: -1 };
const AUDITOR = { role: 'AUDITOR', institutionId: -1 };

export { ROOT, ADMINISTRADOR, AUDITOR, AUDITOR_RECETAS, LECTOR_RECETAS };